import React, { useEffect, useState } from "react";
import { fetchPublicMediaImagesByUse } from "../../services/mediaImageService";
import { WHATSAPP_CHANNEL_URL } from "../../../common/constants";
import "./webImagesSection.css";

const BASE_ROOT = process.env.REACT_APP_BASE_URL_ROOT || process.env.REACT_APP_BASE_URL?.replace(/\/api$/, "");

const WebImagesSection = ({ imageUse, className = "" }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPublicMediaImagesByUse(imageUse).then((res) => {
      if (res.status === 200) setImages(res.data);
      setLoading(false);
    });
  }, [imageUse]);

  if (loading) {
    return (
      <div className={`wi-section-skeletons ${className}`}>
        {[1, 2, 3].map((i) => <div key={i} className="wi-skeleton" />)}
      </div>
    );
  }

  if (images.length === 0) return null;

  return (
    <div className={`wi-section ${className}`}>
      {images.map((img) => (
        <a
          key={img.id}
          href={img.linkUrl || WHATSAPP_CHANNEL_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "contents" }}
        >
          <img
            src={`${BASE_ROOT}${img.url}`}
            alt={img.altText || img.name}
            className="wi-section-img"
            style={{ cursor: "pointer" }}
          />
        </a>
      ))}
    </div>
  );
};

export default WebImagesSection;
